import { render, staticRenderFns } from "./CompetencyDetail.vue?vue&type=template&id=a8180bc6&scoped=true"
import script from "./CompetencyDetail.vue?vue&type=script&lang=js"
export * from "./CompetencyDetail.vue?vue&type=script&lang=js"
import style0 from "./CompetencyDetail.vue?vue&type=style&index=0&id=a8180bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8180bc6",
  null
  
)

export default component.exports